import { Constants } from "./constants";

export class AlbumData {

    public imageUrls: Array<String> = new Array<String>();
    public owner: String = Constants.USER;
    public type: String = 'albumData';
    public _id: String = '';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/albumData.ts